import {Model} from '@chaysehartsuff/active-html';

export default class UserImage extends Model {
    id;
    user_id;
    uuid;
    display_name;
    size;
    mime_type;
    delete_date;
    parent_user_image_folder_id;
    created_at;
    updated_at;
}